import { ProjectEstimateBase } from './base/project-estimate-base';

export class ProjectEstimate extends ProjectEstimateBase {
  private _subTotalItemsAndCccts: number = 0;

  set subTotalItemsAndCccts(newValue: number) {
    this._subTotalItemsAndCccts = newValue;
    this.updateValues();
  }

  get subTotalItemsAndCccts(): number {
    return this._subTotalItemsAndCccts;
  }

  get TotalTax(): number {
    return this.IsTaxPercent ? this.subTotalItemsAndCccts * (this.Tax ? this.Tax : 0) : (this.TaxCost ? this.TaxCost : 0);
  }
  get TotalContingency(): number {
    return this.IsContingencyPercent ? this.subTotalItemsAndCccts * (this.Contingency ? this.Contingency : 0) : (this.ContingencyCost ? this.ContingencyCost : 0);
  }

  set TaxControl(newValue: number) {
    this.Tax = newValue;
    this.updateValues();
  }

  get TaxControl(): number {
    return this.Tax;
  }

  set ContingencyControl(newValue: number) {
    this.Contingency = newValue;
    this.updateValues();
  }

  get ContingencyControl(): number {
    return this.Contingency;
  }

  set TaxCostControl(newValue: number) {
    this.TaxCost = newValue;
    this.updateValues();
  }

  get TaxCostControl(): number {
    return this.TaxCost;
  }

  set ContingencyCostControl(newValue: number) {
    this.ContingencyCost = newValue;
    this.updateValues();
  }

  get ContingencyCostControl(): number {
    return this.ContingencyCost;
  }

  private updateValues() {
    if (this.IsTaxPercent) {
      this.TaxCost = this._subTotalItemsAndCccts * (this.Tax ? this.Tax : 0)
    } else {
      this.Tax = this._subTotalItemsAndCccts !== 0 ? (this.TaxCost ? this.TaxCost : 0) / this._subTotalItemsAndCccts : 0
    }
    if (this.IsContingencyPercent) {
      this.ContingencyCost = this._subTotalItemsAndCccts * (this.Contingency ? this.Contingency : 0)
    } else {
      this.Contingency = this._subTotalItemsAndCccts !== 0 ? (this.ContingencyCost ? this.ContingencyCost : 0) / this._subTotalItemsAndCccts : 0
    }
    this.EstimateTotal = this._subTotalItemsAndCccts + this.TotalTax + this.TotalContingency;
  }
}